import MainLayout from "../layout/MainLayout";
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import Promotion from "../pages/Sections/Promotion/Promotion";
import Probation from "../pages/Sections/Probation/Promotion";
import Compassionate from "../pages/Sections/Compassionate/Promotion";
import SectionDetail from "../pages/Sections/sectionDetail";
import ChatbotPage from "../pages/Chatbot";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const MainRoutes = {
  path: "/",
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: "about-us",
      element: <AboutUs />,
    },
    {
      path: "promotion",
      element: <Promotion />,
    },
    {
      path: "probation",
      element: <Probation />,
    },
    {
      path: "compassionate-appointment",
      element: <Compassionate />,
    },
    {
      path: "chatbot",
      element: <ChatbotPage />,
    },
    {
      path: ":section",
      element: <SectionDetail />,
    },
  ],
};

export default MainRoutes;
